<template>
    <div class="material-detail-wrap" v-if="Object.keys(this.renderData).length">
        <material-detail-header v-if="showHeader" :detail-data="renderData"></material-detail-header>

        <div class="material-detail-container">
            <div class="preview-section">
                <div class="preview-wrapper">
                    <img :src="coverUrl" alt="素材预览" class="preview-image"/>
                    <img
                        v-for="(item, index) in renderData.previewimgpaths"
                        :key="index"
                        :src="item"
                        alt=""
                        class="preview-image"
                    />
                </div>
                <div class="not-vip" v-if="!userInfo.isVip">
                    <a href="javascript:" @click="openMembershipDialog">
                        开通会员
                    </a>
                    可任意浏览{{ previewTotal }}页
                </div>
                <div class="preview-records-info" v-else>
                    <div class="info-left">
                        <div class="have-read">
                            {{ previewPages.length }}/<span>{{ previewTotal }}</span>
                            <br/>
                            已查看
                        </div>
                        <div class="preview-pages" v-if="previewPages.length">
                            <template v-for="(item, index) in previewPages">
                                <div
                                    class="page-item"
                                    :key="index"
                                    :class="{ active: item == preivewIndex }"
                                    @click="previewPageClick(item)"
                                >
                                    {{ item }}
                                </div>
                                <br :key="index" v-if="(index + 1) % 5 === 0 && index + 1 < previewPages.length"/>
                            </template>
                        </div>
                    </div>
                    <div class="info-right">
                        <div class="finish-reading" v-if="previewPages.length === previewTotal">
                            如果查看更多内容，<a
                            href="javascript:"
                            @click="handleVipPurchase(userInfo.isVip ? vipPrice : renderData.saleprice)"
                        >请购买下载</a
                        >
                        </div>
                        <el-input
                            v-else
                            class="preview-input"
                            size="small"
                            v-model="preivewIndex"
                            @input="handlePreviewInput"
                            placeholder="请输入页码"
                        >
                            <el-button slot="append" class="search-btn" @click="handlePreviewAttach">浏览</el-button>
                        </el-input>
                    </div>
                </div>
            </div>
            <div class="info-section">
                <div v-if="renderData.isfree || renderData.ispayed == 1">
                    <div class="state" v-if="renderData.ispayed == 1">
                        <i class="el-icon-success"></i>
                        已购买
                    </div>
                    <el-button type="primary" class="download-btn" @click="downLoadAttach">
                        {{ renderData.isfree ? '免费下载' : '立即下载' }}
                    </el-button>
                </div>
                <div v-else>
                    <div class="vip-price-info" v-if="userInfo.isVip">
                        <div class="price-info">
                            <span class="vip-tag">
                                <img :src="iconVip" alt=""/>
                                {{ vipName }}
                            </span>
                            <span class="price"
                            >¥ <span>{{ vipPrice }}</span></span
                            >
                            <span class="original-price">¥ {{ renderData.saleprice }}</span>
                        </div>
                        <el-button type="primary" class="pay-btn" @click="handleVipPurchase(vipPrice)"
                        >立即购买
                        </el-button
                        >
                    </div>
                    <div class="normal-price-info" v-else>
                        <div class="price-info">
                            <span class="price"
                            >价格 ¥<span>{{ renderData.saleprice }}</span></span
                            >
                        </div>
                        <el-button
                            type="primary"
                            class="vip-pay-btn"
                            @click="handleVipPurchase((renderData.saleprice * 0.6).toFixed(2))"
                        >
                            <label>
                                开通会员
                            </label>
                            最低 ¥<span>{{ (renderData.saleprice * 0.6).toFixed(2) }}</span>
                        </el-button>
                        <el-button class="pay-btn" @click="handlePurchase">
                            ¥ <span>{{ renderData.saleprice }}</span> 购买
                        </el-button>
                    </div>
                </div>
                <el-button class="collect-btn" @click="handleCollect">
                    <i :class="['el-icon-star-off', { 'el-icon-star-on': renderData.iscollected == 1 }]"></i>
                    {{ renderData.iscollected == 1 ? '已收藏' : '收藏' }}
                </el-button>
                <div class="info-cells">
                    <p>
                        <label>
                            提示：
                        </label>
                        {{ renderData.tip }}
                    </p>
                    <p>
                        <label>
                            授权：
                        </label>
                        {{ renderData.accredit }}
                    </p>
                </div>
                <div class="material-info">
                    <h3>素材详情</h3>
                    <div class="info-cells">
                        <p>
                            <label>
                                上传时间：
                            </label>
                            {{ renderData.releasedate }}
                        </p>
                        <p>
                            <label>
                                页数：
                            </label>
                            {{ renderData.pagesize }}页
                        </p>
                        <p>
                            <label>
                                素材编号：
                            </label>
                            {{ renderData.materialno }}
                        </p>
                    </div>
                </div>
                <div class="uploader-info" v-if="showSimilar">
                    <h3>上传人</h3>
                    <div class="uploader-profile" @click="toUploader()">
                        <img :src="renderData.profilepicurl" alt="上传者头像" class="avatar"/>
                        <div class="uploader-detail">
                            <span class="username">{{ renderData.shopname }}</span>
                            <span class="authentication">已认证{{ renderData.relationtypetext }}</span>
                        </div>
                        <i class="el-icon-arrow-right"></i>
                    </div>
                </div>
                <div class="similar-section" v-if="showSimilar">
                    <h3>
                        相似推荐
                        <span @click="handleRefresh">
                            换一换
                            <i class="el-icon-refresh-right" :class="{ 'rotate-animation': isRotating }"></i>
                        </span>
                    </h3>
                    <div class="similar-list">
                        <div
                            v-for="item in similarItems.list"
                            :key="item.guid"
                            class="similar-item"
                            @click="handleSimilarItemClick(item)"
                        >
                            <div class="item-cover">
                                <img :src="item.thumbnailurl" alt="封面"/>
                            </div>
                            <div class="item-info">
                                <div class="item-title" :title="item.materialtitle">{{ item.materialtitle }}</div>
                                <div class="item-other">
                                    <span class="page-count">{{ item.pagesize }}页</span>
                                    <div class="item-author">
                                        <img :src="avatar(item.profilepicurl)" class="author-avatar" alt="作者头像"/>
                                        <span class="author-name" :title="item.shopname">{{ item.shopname }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <el-dialog
            :visible.sync="previewDialog"
            :title="'第' + preivewIndex + '页内容'"
            append-to-body
            @close="closePreviewDialog"
            :close-on-press-escape="false"
            :close-on-click-modal="false"
            width="640px"
            custom-class="preview-dialog"
        >
            <div class="preview-dialog-container">
                <img :src="previewUrl" alt=""/>
            </div>
        </el-dialog>

        <triton-master-dialog
            v-if="tritonMasterDialog.show"
            :relation-guid="tritonMasterDialog.relationguid"
            :shop-guid="tritonMasterDialog.shopguid"
            @closeDialog="tritonMasterDialogClose"
        ></triton-master-dialog>

        <pay-dialog-iframe
            v-if="payDialog.show"
            :materialguid="payDialog.materialguid"
            :price="payDialog.price"
            :originalprice="payDialog.originalprice"
            @close="closePayDialog"
        ></pay-dialog-iframe>
    </div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex';
import MaterialDetailHeader from '@/views/material-market/components/material-detail-header.vue';
import TritonMasterDialog from '@/views/triton-master/components/triton-master-dialog.vue';
import payDialogIframe from '@/views/material-market/components/pay-dialog-iframe.vue';
import DEFAULT_AVATAR from '@/views/material-market/images/icon_user.png';
import ICON_VIP from '@/views/material-market/images/icon_vip.png';
import ICON_VIP2 from '@/views/material-market/images/icon_vip2.png';
import {downloadAttach} from '@/util/util';

export default {
    name: 'MaterialDetail',
    components: {
        MaterialDetailHeader,
        TritonMasterDialog,
        payDialogIframe
    },
    props: {
        showHeader: {
            type: Boolean,
            default: true
        },
        detailData: {
            type: Object,
            default: () => {
            }
        },
        showSimilar: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            renderData: {},
            similarItems: {
                list: [],
                total: 0
            },
            isFree: false,
            isRotating: false,
            coverUrl: '',
            previewUrl: '',
            preivewIndex: '',
            previewTotal: 10,
            previewPages: [],
            previewDialog: false,
            iconVip: '',
            tritonMasterDialog: {
                show: false,
                fullScreen: false,
                relationguid: '',
                shopguid: ''
            },
            payDialog: {
                show: false,
                materialguid: '',
                price: '',
                originalprice: ''
            },
            similarMaterialParams: {
                pageindex: 0,
                pagesize: 5
            }
        };
    },
    computed: {
        ...mapGetters(['userInfo']),
        vipName() {
            let issvip = this.userInfo.vips.find((item) => item.type === 'SVIP');
            return issvip ? '超级会员' : '尊享会员';
        },
        vipPrice() {
            let price = 0;
            let issvip = this.userInfo.vips.find((item) => item.type === 'SVIP');
            price = (this.renderData.saleprice * (issvip ? 0.6 : 0.8)).toFixed(2);
            price = price < 0.01 ? 0.01 : price;
            if (this.renderData.saleprice <= 0) {
                price = 0;
            }
            return price;
        }
    },
    watch: {
        detailData() {
            this.init();
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        ...mapActions(['getUserInfo', 'openMembershipDialog']),
        init() {
            if (this.detailData.materialguid) {
                this.renderData = {
                    ...this.detailData,
                    isfree: this.detailData.saleprice == 0
                };
                if (this.renderData.vipname) {
                    this.iconVip = this.renderData.vipname.indexOf('尊享会员') !== -1 ? ICON_VIP2 : ICON_VIP;
                }
                this.coverUrl = this.renderData.previewimgpaths[0];
                this.preivewIndex = '';
                this.getPreviewHistroy();
                this.showSimilar && this.getSimilarMaterialList();
                this.getOperationRecord();
            }
        },
        getOperationRecord() {
            this.$Api
                .getOperationRecord({
                    materialguid: this.renderData.materialguid,
                    userguid: this.userInfo.userguid
                })
                .then((data) => {
                    this.$set(this.renderData, 'ispayed', data.ispayed);
                    this.$set(this.renderData, 'iscollected', data.iscollected);
                });
        },
        getPreviewHistroy() {
            this.$Api
                .getPreviewHistroy({
                    materialguid: this.renderData.materialguid,
                    userguid: this.userInfo.userguid
                })
                .then((data) => {
                    this.previewPages = data.pagenumbers;
                });
        },
        // 会员购买
        handleVipPurchase(price) {
            // TODO: 实现购买逻辑
            if (this.userInfo.isVip) {
                this.openPayDialog(price);
            } else {
                this.openMembershipDialog(this.detailData.materialguid);
            }
        },
        // 普通购买
        handlePurchase() {
            // TODO: 实现购买逻辑
            let price = this.renderData.saleprice;
            this.openPayDialog(price);
        },

        // 收藏
        handleCollect() {
            let iscollected = this.renderData.iscollected == '0' ? '1' : '0';
            this.$Api
                .setMaterialCollected({
                    materialguid: this.renderData.materialguid,
                    userguid: this.userInfo.userguid,
                    isadd: iscollected == 1
                })
                .then((data) => {
                    if (data.state === 'success') {
                        this.$set(this.renderData, 'iscollected', iscollected);
                    }
                    this.$message({
                        type: data.state,
                        message: data.message
                    });
                });
        },
        // 相似推荐
        getSimilarMaterialList() {
            this.$Api
                .getSimilarMaterialList({
                    materialguid: this.renderData.materialguid,
                    ...this.similarMaterialParams
                })
                .then((data) => {
                    this.isRotating = false;
                    this.similarItems.list = data.materiallist;
                    this.similarItems.total = data.pageinfo.totalnumcount;
                });
        },
        // 相似推荐点击
        handleSimilarItemClick(item) {
            this.$emit('getDetail', item.materialguid);
        },
        avatar(avatar) {
            return avatar || DEFAULT_AVATAR;
        },
        // 换一换
        handleRefresh() {
            this.isRotating = true;
            let index = Math.ceil(this.similarItems.total / this.similarMaterialParams.pagesize);
            let pageIndex = this.similarMaterialParams.pageindex + 1;
            if (index * this.similarMaterialParams.pagesize >= (pageIndex + 1) * this.similarMaterialParams.pagesize) {
                this.similarMaterialParams.pageindex++;
            } else {
                this.similarMaterialParams.pageindex = 0;
            }
            this.getSimilarMaterialList();
        },
        // 跳转上传人
        toUploader() {
            this.tritonMasterDialog.relationguid = this.renderData.relationguid;
            this.tritonMasterDialog.shopguid = this.renderData.shopguid;
            this.tritonMasterDialog.show = true;
        },
        tritonMasterDialogClose() {
            this.tritonMasterDialog.show = false;
            this.tritonMasterDialog.fullScreen = false;
        },
        // 素材下载
        downLoadAttach() {
            this.$Api
                .getDownloadPath({
                    userguid: this.userInfo.userguid,
                    materialguid: this.renderData.materialguid
                }, {
                    showLoading: true
                })
                .then((data) => {
                    if (data.isPassSensitie) {
                        let url = data.downloadpath;
                        downloadAttach(url);
                        this.$Api
                            .setDownloadStatus({
                                userguid: this.userInfo.userguid,
                                materialguid: this.renderData.materialguid
                            })
                    } else {
                        this.$message.error('数据异常，请联系客服处理！')
                    }
                });
        },
        handlePreviewInput(e) {
            // 只保留数字部分
            // 只保留数字部分
            const numStr = String(e).replace(/[^\d]/g, '');
            if (!numStr) {
                this.preivewIndex = '';
                return;
            }

            const num = parseInt(numStr);
            if (num > this.renderData.pagesize) {
                this.preivewIndex = this.renderData.pagesize;
            } else if (num < 1) {
                this.preivewIndex = 1;
            } else {
                this.preivewIndex = num;
            }
        },
        handlePreviewAttach() {
            if (!this.preivewIndex) {
                this.$message({
                    type: 'error',
                    message: '请输入页码'
                });
                return;
            }

            this.$Api
                .getDesignatedPage({
                    materialguid: this.renderData.materialguid,
                    userguid: this.userInfo.userguid,
                    pagenumber: this.preivewIndex
                },{
                    showLoading:true
                })
                .then((data) => {
                    this.previewUrl = data.previewimgpath;
                    this.previewDialog = true;
                });
        },
        closePreviewDialog() {
            this.previewDialog = false;
            this.previewUrl = '';
            // 如果页码不存在于数组中才添加
            let preivewIndex = this.preivewIndex.toString();
            if (!this.previewPages.includes(preivewIndex)) {
                this.previewPages.push(preivewIndex);
            }
        },
        previewPageClick(preivewIndex) {
            this.preivewIndex = preivewIndex;
            this.handlePreviewAttach();
        },
        openPayDialog(price) {
            this.payDialog.materialguid = this.renderData.materialguid;
            this.payDialog.originalprice = this.renderData.saleprice.toString();
            this.payDialog.price = price.toString();
            this.payDialog.show = true;
        },
        closePayDialog() {
            this.payDialog.show = false;
            this.getUserInfo().then(() => {
                this.$emit('getDetail', this.detailData.materialguid);
            });
        }
    }
};
</script>
<style lang="scss" scoped>
@import '../style/common.scss';
@import './style/material-detail.scss';
</style>
